import { render, staticRenderFns } from "./companies-list.vue?vue&type=template&id=2f17db18&scoped=true"
import script from "./companies-list.vue?vue&type=script&lang=js"
export * from "./companies-list.vue?vue&type=script&lang=js"
import style0 from "./companies-list.vue?vue&type=style&index=0&id=2f17db18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f17db18",
  null
  
)

export default component.exports